// extracted by mini-css-extract-plugin
module.exports = {"container":"Profit_container__Ir1HF","price":"Profit_price__OUrN_","company":"Profit_company__kSbUJ"};